var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPdf32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 33.2V4H10v32h15.5",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0H2a2 2 0 0 0-2 2v24h40V2a2 2 0 0 0-2-2Z",
    fill: "#F15642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26H0v12c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V26Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 30.6c0-.3.3-.6.6-.6h2c1.3 0 2.3.8 2.3 2.5 0 1.5-1 2.3-2.2 2.3H13V36c0 .5-.3.6-.6.6s-.6-.1-.6-.6v-5.4Zm1.2.6v2.3h1.5c.6 0 1-.6 1-1 0-.7-.4-1.3-1-1.3H13Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 36.6c-.3 0-.6-.1-.6-.6v-5.4c0-.3.3-.6.6-.6h2.1c4.2 0 4.2 6.6.2 6.6h-2.3Zm.6-5.4v4.3h1.5c2.6 0 2.6-4.3 0-4.3h-1.5Z",
    fill: "#F15642"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.2v1.6h2.4c.3 0 .6.3.6.6s-.3.6-.6.6h-2.4v2c0 .3-.3.6-.6.6-.5 0-.6-.3-.6-.6v-5.4c0-.3.3-.6.6-.6h3.3c.3 0 .6.3.6.6s-.3.6-.6.6h-2.7Z",
    fill: "#F15642"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4c-.9 0-1.6.9-1.5 1.7.2 1.4 1 2.4 1.7 3.5l-.2 1.3c-.4 2.4-1 4.7-2 7-1.4.5-2.8 1-3.5 2.3-.5 1 .1 2 1.1 2.2 1 .1 1.6-.7 2-1.3.6-.7 1-1.5 1.4-2.3 2.6-1 5.3-1.8 8-2 1.2.8 2.4 1.7 3.9 1.8.8 0 1.5-.9 1.4-1.7 0-.7-.7-1.3-1.4-1.4-1.1-.3-2.3-.2-3.5-.2a29 29 0 0 1-5.8-6c.1-1.4.4-3-.4-4.3-.2-.4-.7-.6-1.2-.6Zm0 1.3c.3 0 .3.4.4.6V7c-.3-.5-.7-1.1-.6-1.8h.2Zm1.4 5.4c1.3 1.7 2.7 3.2 4.3 4.5-2 .3-4.1.9-6.1 1.6.7-2 1.3-4 1.7-6.2v.1Zm8.1 5.5c.5 0 1.1 0 1.5.4 0 .3-.3.3-.5.2-.4-.1-.9-.3-1.2-.6h.2Zm-12.6 3.3a4 4 0 0 1-1 1.2c-.1.2-.4-.2-.3-.3.3-.5.9-.8 1.4-1l-.1.1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf32);
export default ForwardRef;